import { Injectable } from '@angular/core';
import { arrowNarrowIcon } from '../sharedcomp/constans/icons.constans';

@Injectable()
export class CreationBatch {
  public _creation: {value: number; name: string}[] = [
    { value: 0, name: 'TODOS' },
    { value: 1, name: 'Este Mes' },
    { value: 2, name: 'Esta Semana' },
    { value: 3, name: 'Hoy' },
    { value: 4, name: 'Ayer' },
    { value: 5, name: 'Semana Pasada' },
    { value: 6, name: 'Mes Pasado' },
    { value: 7, name: 'Rango' }
  ];

  public _newCreation : {value: number; name: string}[] = [
    { value:0, name: 'Hoy' } ,
    { value:1, name: 'Ayer' } ,
    { value:2, name: 'Esta semana' },
    { value:3, name: 'La semana pasada' },
    { value:4, name: 'Este mes' },
    { value:5, name: 'Mes pasado' },
    { value:6, name: 'Este año' },
    { value:7, name: 'Año pasado' },
    { value:8, name: 'Todo' }
  ];

  constructor() { }
}


@Injectable()
export class StatusBatch {
  public _status: any[] = [
    { value: 0, name: 'TODOS' },
    { value: 1, name: 'Nuevos' },
    { value: 2, name: 'En Proceso' },
    { value: 3, name: 'Completado' },
    { value: 4, name: 'No Procesado' },
  ];

  public _batchesStatusV2: BatchStatusV2[] = [
    { value: 0, name: 'TODOS', cssStyle: { 'color': '' }, isIcon: false },
    { value: 1, name: 'Nuevos', cssStyle: { 'color': '#2E90FA' }, isIcon: false },
    { value: 2, name: 'En Proceso', cssStyle: { 'color': '#287BEE' }, isIcon: false },
    { value: 3, name: 'Completado', cssStyle: { 'color': '#17B26A' }, isIcon: false },
    { value: 4, name: 'No Procesado', cssStyle: { 'color': '#F04438' }, isIcon: false }
  ];

  constructor() { }
}

@Injectable()
export class TypeBatch {
  public _type: any[] = [
    { value: 0, name: 'TODOS' },
    { value: 1, name: 'Entradas' },
    { value: 2, name: 'Salidas' },
  ];

  public _batchesTypeV2: BatchTypeV2[] = [
    { value: 0, name: 'TODOS', cssStyle: { 'color': '' }, isIcon: false},
    { value: 1, name: 'Entradas', cssStyle: { 'color': '' }, isIcon: true, iconPath: arrowNarrowIcon.path, iconAlt: '' },
    { value: 2, name: 'Salidas', cssStyle: { 'transform': 'rotate(180deg)' }, isIcon: true, iconPath: arrowNarrowIcon.path, iconAlt: '' },
  ];

  constructor() { }
}

export interface BatchTypeV2 {
  name:         'TODOS' | 'Entradas' | 'Salidas';
  value:        number;
  cssStyle:     Record<string, string>;
  isIcon:       boolean;
  iconPath?:    string;
  iconAlt?:     string;
}


export interface BatchStatusV2 {
  name:         'TODOS' | 'Nuevos' | 'En Proceso' | 'Completado' | 'No Procesado';
  value:        number;
  cssStyle:     Record<string, string>;
  isIcon:       boolean;
  iconPath?:    string;
  iconAlt?:     string;
}

